var PDNObject = require('./PDNObject');

function PDNParser(pdnText) {
    // Tag Pair
    this._patternTagPair = /\[\s*(\w*)\s*\\*"(.*?)\\*"\s*\]/;
//    '\\[\\s*' + tagPairKey + '\\s*(|[^\\"]")*([\\w\\s.:,-?;]*)(|[^\\"]")*\\s*\\]'
    // MoveText
    this._patternMoveText = /\s*\s*(?:(\d+)\.(?:\.\.|\s+\.\.\.)?)?\s*(\d+(?:[-x]\d+)+)([!?*()]*)\s+(?:\{([^}]*)\}){0,1}\s*(?:(\d+(?:[-x]\d+)+)([!?*()]*)\s+?(?:\{([^}]*)\}){0,1})?\s*\s*/g;

    // Game-termination :
    // " 1-0 " ; " 0-1 " ; " 1/2-1/2 " ; " * "
    // " 2-0 " ; " 0-2 " ; " 1-1 "
    // Note : no confusion with move notation because of zero square do not exist and move on contigus squares is not valid
    // idem with asterisk and move 'glyph' because of leading and trailing space.
    this._patternGameTermination = /\s([012]-[012]|1\/2-1\/2|\*)\s+\n/g;

    // FEN Tag value
    this._patternFEN = /^"*(W|B):(W|B)((?:K?\d*)(?:,K?\d+)*?)(?::(W|B)((?:K?\d*)(?:,K?\d+)*?))\\*"*?$/;

    this.pdnSourceText = null;
    this.indexes = null;

    this.setPDNText(pdnText);
}


PDNParser.prototype.setPDNText = function(pdnText) {
    
    this.pdnSourceText = pdnText ? pdnText : null;

    if (this.pdnSourceText !== null){
        this._init();
    }
};

PDNParser.prototype._init = function() {
    this.pdnSourceText = this.pdnSourceText.trim() + " "; // for regexp...
    this.pdnSourceText = this.pdnSourceText.replace(/\\r\\n/g, ' ');
    this.pdnSourceText = this.pdnSourceText.replace(/\\n/g, ' ');
    this.indexes = this._cutPDN();
    this._parseNameOfGames();
};

PDNParser.prototype._readyToParse = function(numGame) {
    var b = true;

    if (this.pdnSourceText === null) {
        b = false;
    } else if (numGame <= 0 || numGame > this.indexes.length) {
        b = false;
    }

    return b;
};

PDNParser.prototype.parse = function(numGame) {
    var pdnObj = new PDNObject();

    if (!this._readyToParse(numGame)) {
        return pdnObj;
    }

    // ------------------
    // Parse PDN
    // ------------------
    var pdn = this._parsePDN(numGame);

    var tags  = pdn["tagPairs"];
    var moves = pdn["moveText"];
    var gameTermination = pdn["gameTermination"];

    pdnObj.setTagPairs(tags);
    pdnObj.setMoveText(moves);
    pdnObj.setGameTermination(gameTermination);

    // ------------------
    // Parse FEN
    // ------------------
    var fen = pdnObj.getTagPair("FEN");
    if (fen !== "??") {
        pdnObj.fen = fen;
        var map = this._parseTagFEN(fen);
        if (map !== null) {
            pdnObj.setFenWP(map["WP"]);
            pdnObj.setFenBP(map["BP"]);
            pdnObj.setFenWK(map["WK"]);
            pdnObj.setFenBK(map["BK"]);
            pdnObj.setFenTurnColor(map["turnColor"]);
        }
    }

    return pdnObj;
};

PDNParser.prototype.getGameCount = function() {
    var nb = 0;
    if (this.indexes != null) {
        nb = this.indexes.length;
    }
    return nb;
};

PDNParser.prototype.isTagValueEmpty = function(value) {
    return (value == null || value === "??");
};


PDNParser.prototype._parseTagFEN = function(fen) {
    if (this.isTagValueEmpty(fen)) {
        return null;
    }

    let turnColor = "";
    let whitePawnPositions = [];
    let whiteKingPositions = [];
    let blackPawnPositions = [];
    let blackKingPositions = [];

    let m = this._patternFEN.exec(fen);
    //let m = fen.match(this._patternFEN);
    if (m != null) {
    
        // let source = m[0];
        turnColor = m[1];
        let color1 = m[2];
        let color1Position = m[3];
        let color2 = m[4];
        let color2Position = m[5];

        if (color1Position !== null && color1Position !== "") {
            let isWhite = (color1 === "W");
            let positions = color1Position.split(",");

            let map = this._getPawnAndKingList(positions);
            if (isWhite) {
                whitePawnPositions = map["pawn"];
                whiteKingPositions = map["king"];
            } else {
                blackPawnPositions = map["pawn"];
                blackKingPositions = map["king"];
            }
        }

        if (color2Position !== null && color2Position !== "") {
            let isWhite = (color2 === "W");
            let positions = color2Position.split(",");

            let map = this._getPawnAndKingList(positions);
            if (isWhite) {
                whitePawnPositions = map["pawn"];
                whiteKingPositions = map["king"];
            } else {
                blackPawnPositions = map["pawn"];
                blackKingPositions = map["king"];
            }
        }
    }

    let map = {};
    map["WP"] = whitePawnPositions;
    map["WK"] = whiteKingPositions;
    map["BP"] = blackPawnPositions;
    map["BK"] = blackKingPositions;
    map["turnColor"] = turnColor;

    return map;
};

PDNParser.prototype._getPawnAndKingList = function(positions) {
    let pawnPositions = [];
    let kingPositions = [];

    if (positions != null && positions.length > 0) {
        for (let k = 0; k < positions.length; k++) {
            let pos = positions[k];
            if (pos.length > 0) {
                let sf = pos.substring(0, 1);
                let isKing = (sf === "K");

                if (isKing) {
                    pos = pos.substring(1);
                }

                let iPos = parseInt(pos, 10);
                if (!isNaN(iPos)){
                    if (isKing) {
                        kingPositions.push(iPos);
                    } else {
                        pawnPositions.push(iPos);
                    }
                }
            }
        }
    }

    let map = {};
    map["pawn"] = pawnPositions;
    map["king"] = kingPositions;
    return map;
};


PDNParser.prototype._cutPDN = function() {
    let liste = []; // [{string:string}]
    if (this._patternGameTermination.test(this.pdnSourceText) === false) {
        this.pdnSourceText += '* \n';
    }

    this._patternGameTermination.lastIndex = 0;
    let idxNextGame = 0;
    let match;
    let cpt = 0;
    
    while ((match = this._patternGameTermination.exec(this.pdnSourceText)) !== null) {
        cpt++; if (cpt>200) break; // security
        
        let idxStart = match.index;
        let idxEnd = idxStart + match[0].length;

        let map = {};
        map["idxStartGame"] = "" + idxNextGame;
        map["idxStartGameTermination"] = "" + idxStart;
        map["idxEndGame"] = "" + idxEnd;
        liste.push(map);

        idxNextGame = idxEnd;

        //console.log(match);
        //console.log("(" + idxStart + ", " +  idxEnd + ") = '" + this.pdnSourceText.substring(idxStart, idxEnd) + "'");
    }

    return liste;
};

PDNParser.prototype._parseNameOfGames = function() {
    for (let k = 0; k < this.indexes.length; k++) {
        let h = this.indexes[k];
        let idxStart = h["idxStartGame"];
        let idxEnd   = h["idxEndGame"];

        let cText = this.pdnSourceText.substring(idxStart, idxEnd);
        cText = cText.trim() + " ";

        h["tagEvent"] = this._extractTagPairValueForKey(cText, "Event");
        h["tagDate"]  = this._extractTagPairValueForKey(cText, "Date");
        h["tagWhite"] = this._extractTagPairValueForKey(cText, "White");
        h["tagBlack"] = this._extractTagPairValueForKey(cText, "Black");
        h["tagRound"] = this._extractTagPairValueForKey(cText, "Round");
        h["tagResult"] = this._extractTagPairValueForKey(cText, "Result");
        h["tagFen"] = this._extractTagPairValueForKey(cText, "FEN");
    }
};

PDNParser.prototype._extractTagPairValueForKey = function(gameText, tagPairKey) {
    //let re = new RegExp("\\[\\s*" + tagPairKey + "\\s*\"(\\w+)\"\\s*\\]", "gi");
    let s = '\\[\\s*' + tagPairKey + '\\s*(|[^\\"]")*([\\w\\s.:,-?;]*)(|[^\\"]")*\\s*\\]';
    let re = new RegExp(s, "gi");
    let m = re.exec(gameText);

    let value = "";
    if (m != null) {
        value = m[2].trim();
    }

    if (value === "") {
        value = "??";
    }

    return value;
};

PDNParser.prototype.getTitle = function(numGame, pattern) {
    if (!this._readyToParse(numGame)) {
        return "";
    }

    if (!pattern) {
        pattern = "tagEvent (tagDate) : tagWhite - tagBlack [tagRound] - tagResult";
    }

    let h = this.indexes[numGame - 1];
    let keywords = ["tagEvent", "tagDate", "tagWhite", "tagBlack", "tagRound", "tagResult"];

    let title = pattern;
    for (let k = 0; k < keywords.length; k++) {
        let keyword = keywords[k];
        title = title.replace(keyword, h[keyword]);
    }
    return title;
};

PDNParser.prototype.getTitles = function(pattern) {
    let list = [];

    let nb = this.getGameCount();
    for (let k = 0; k < nb; k++) {
        let numGame = k + 1;
        let title = this.getTitle(numGame, pattern);
        list.push({'num':numGame, 'title':title});
    }
    return list;
};


PDNParser.prototype._parsePDN = function(numGame) {
    let m = this.indexes[numGame - 1];

    let idxStart = parseInt(m["idxStartGame"], 10);
    let idxEnd   = parseInt(m["idxEndGame"], 10);

    let cText = this.pdnSourceText.substring(idxStart, idxEnd);

    // TODO: comment before moveText section
    // TODO: endline comment "; this is an endline comment"

    // ------------------
    // TAG PAIRS
    // ------------------
    let mapTags = this._parseTagPairs(cText);

    // ------------------
    // MOVE TEXT
    // ------------------
    let idx = this._getNextIndex(mapTags);
    let lmMoves = this._parseMoveText(cText, idx);

    // Cleanup
    delete mapTags["nextIndexToParse"];

    // Deballage
    let gameTermination = null;
    if (lmMoves.length > 0) {
        let map = lmMoves[0];
        gameTermination = map["gameTermination"];
        // map["nextIndexToParse"];

        lmMoves = lmMoves.slice(1, lmMoves.length);
    }

    // ------------------
    let res = {};
    res["tagPairs"] = mapTags;
    res["moveText"] = lmMoves;
    res["gameTermination"] = gameTermination;

    return res;
};

PDNParser.prototype._parseTagPairs = function(texte) {
    let map = {};
    map["nextIndexToParse"] = "0";

    let rTexte = texte.trim();
    while (rTexte.substring(0, 1) === "[") {

        let i = rTexte.indexOf("]", 1);
        if (i === -1) {
            console.log("Erreur");
            return null;
        }

        let tag = rTexte.substring(0, i + 1);
        rTexte = rTexte.substring(i + 2).trim();

        // ---

        let m = this._patternTagPair.exec(tag);
        //let m = fen.match(this._patternFEN);
        if (m != null) {
            let key = m[1];
            let value = m[2];

            // Normalisation
            value = value.trim();
            if (key === "FEN") {
                value = value.replace(" ", "");
            }
            // --------------
            map[key] = value;

            let idx = texte.indexOf(tag);
            if (idx !== -1) {
                idx = idx + tag.length;
                map["nextIndexToParse"] = "" + idx;
            }
        }

    }

    return map;
};

PDNParser.prototype._getNextIndex = function(map) {
    if (map == null) {
        return -1;
    }

    let idx = parseInt(map["nextIndexToParse"], 10);
    return idx;
};

PDNParser.prototype._parseMoveText = function(texte, idx) {
    let liste = [];

    let rTexte = texte.substring(idx);
    rTexte = rTexte + " "; // Pour la regexp

    // Game-termination
    this._patternGameTermination.lastIndex = 0; // Reset the starting position of the next call
    let m = this._patternGameTermination.exec(rTexte);
    //let m = rTexte.match(this._patternGameTermination);
    if (m == null) {
        console.log("Game termination not found !");
        return liste;
    }

    let idxStart = m.index;
    let idxEnd = idxStart + m[0].length;
    let gameTermination = rTexte.substring(idxStart, idxEnd).trim();

    // Metadata on list
    let idxNextGame = idx + idxEnd;
    // ---
    let moveText = rTexte.substring(0, idxStart);
    moveText = moveText.trim();
    moveText = moveText + " "; // for next regexp.

    let map = {};
    map["nextIndexToParse"] = "" + idxNextGame;
    map["gameTermination"] = gameTermination;
    map["text"] = moveText;
    liste.push(map);
    

    let cpt = 0;
    let match;
    while ((match = this._patternMoveText.exec(moveText)) !== null) {
        cpt++; if (cpt>200) break; // security
        
        let dic = [];
        dic["source"]     = match[0];
        dic["moveNumber"] = match[1];
        dic["move1"]      = this._normalize(match[2]);
        dic["glyph1"]     = this._normalize(match[3]);
        dic["comment1"]   = this._normalize(match[4]);
        dic["move2"]      = this._normalize(match[5]);
        dic["glyph2"]     = this._normalize(match[6]);
        dic["comment2"]   = this._normalize(match[7]);
        liste.push(dic);
    }

    return liste;
};

PDNParser.prototype._normalize = function(sValue) {
    if (sValue == null) {
        sValue = "";
    }
    return sValue.trim();
};





PDNParser.prototype.debugCutGames = function() {
    console.log("");
    console.log("----------------------------------------");
    console.log(" Cut Games :");
    console.log("----------------------------------------");
    if (this.indexes === null || this.indexes.length === 0) {
        console.log("Erreur...");
        return;
    }

    console.log("Nombre de parties : " + this.indexes.length);
    console.log("----------");

    for (let h = 0; h < this.indexes.length; h++) {
        let map = this.indexes[h];
        let keys = Object.keys(map);
        for (let k = 0; k < keys.length; k++) {
            let key = keys[k];
            console.log(key + " = " + map[key]);
        }
        console.log("----------");
    }


    for (let h = 0; h < this.indexes.length; h++) {
        let map = this.indexes[h];
        
        let idxStartGame = parseInt(map["idxStartGame"], 10);
        let idxEndGame = parseInt(map["idxEndGame"], 10);
        console.log(this.pdnSourceText.substring(idxStartGame, idxEndGame));
        console.log("----------");
    }

};

module.exports = PDNParser;




// WEBPACK FOOTER //
// ./src/board/PDNParser.js